module.exports = __webpack_public_path__ + "img/icon-test.2bb48d26.png";